import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class IconService {
  constructor(
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  connectIcons(): void {
    this.matIconRegistry.addSvgIcon(
      'password',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/password.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'eye',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/password-eye.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'folder-eye',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/folder_eye.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'groups',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/groups.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'flowchart',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/flowchart.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'search',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/search.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'sort-icon',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/sort-icon.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'library',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/library.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'personal-details',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/personal-details.svg')
    );
    // Search field clear button, 17px circled X (Figma node 6258:354532)
    this.matIconRegistry.addSvgIcon(
      'clear-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/clear-circle.svg')
    );
    // Inline notification icons, 16px, drawn in currentColor (Figma nodes 3357:60428, 3360:64196)
    this.matIconRegistry.addSvgIcon(
      'info-outline',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/info-outline.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'error-outline',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/error-outline.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'check-circle',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/check-circle.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'schedule',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/schedule.svg')
    );
    this.matIconRegistry.addSvgIcon(
      'group',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/custom-icons/group.svg')
    );
    // State flow builder stage cards and requirement rows (Figma nodes 1184:176501, 849:76216)
    for (const name of [
      'stage-lock',
      'stage-initial',
      'stage-parallel',
      'stage-final',
      'chevron-down',
      'chevron-up',
      'req-radio',
      'req-upload',
      'req-check-circle',
      'rule',
      'more-vert',
    ]) {
      this.matIconRegistry.addSvgIcon(
        name,
        this.domSanitizer.bypassSecurityTrustResourceUrl(`assets/custom-icons/${name}.svg`)
      );
    }
  }
}
